// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_core_auth_auth_module_ts":"bd2568f4370c4a1d","src_app_core_auth_init_init_module_ts":"7c1702eff5be25c6"}[chunkId] + ".js";
};